import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-posh',
  templateUrl: './posh.component.html',
  styleUrls: ['./posh.component.css']
})
export class POSHComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
